import { render, staticRenderFns } from "./InstantEstimation.vue?vue&type=template&id=06951ae4&"
import script from "./InstantEstimation.vue?vue&type=script&lang=js&"
export * from "./InstantEstimation.vue?vue&type=script&lang=js&"
import style0 from "./InstantEstimation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InstantEstimation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports